import React from 'react';

import { Button as AntdButton } from 'antd';
import moment from 'moment';

import { ConfigurationHistoriqueDto } from 'lib_api/lib/api/gen';

import TableWithoutPaginationAndSort from 'components/WrappedComponents/Table/TableWithoutPaginationAndSort';
import { ColumnProps } from 'components/WrappedComponents/Table/types';
import { DATE_FORMAT_WITH_TIME } from 'utils/formats';

import { configuration_labels } from '../../labels';

import { useGetConfigurationHistorique } from './UseGetConfigurationHistorique';

interface HistoriqueTableProps {
  idCorrelation: string;
  onSelectHistorique: (historique: ConfigurationHistoriqueDto) => void;
}

export default function HistoriqueTable({
  idCorrelation,
  onSelectHistorique,
}: HistoriqueTableProps): React.ReactElement {
  const { fetchData, filter, setFilter } =
    useGetConfigurationHistorique(idCorrelation);
  const buildColumns = (): ColumnProps<ConfigurationHistoriqueDto>[] => {
    return [
      {
        title: configuration_labels.DATE,
        buildCellContent: data =>
          moment(data.endOfValidity).format(DATE_FORMAT_WITH_TIME),
      },
      {
        title: configuration_labels.DESCRIPTION,
        buildCellContent: data => data.description,
      },
      {
        title: configuration_labels.VALEUR,
        buildCellContent: data => data.value,
      },
      {
        title: '',
        buildCellContent: data => (
          <AntdButton onClick={() => onSelectHistorique(data)}>
            Insérer
          </AntdButton>
        ),
      },
    ];
  };

  return (
    <>
      <h3 className="mainTitle" id="modal-title">
        Historique
      </h3>
      <TableWithoutPaginationAndSort
        columns={buildColumns()}
        fetchData={fetchData}
        buildItemKey={(item): string => item.id}
        filter={filter}
        setFilter={setFilter}
      />
    </>
  );
}
